import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams, useLocation, Navigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { PageSEO } from "@/components/PageSEO";
import { SEO } from "@/lib/seo";
import {
  API, SERVICES, PROBLEMS, SOLUTIONS, METHOD_STEPS,
  TESTIMONIALS_DATA, LOCATIONS, SOCIAL_LINKS, WHATSAPP_NUMBER,
  CONTACT_EMAIL, TEAM_ITEMS
} from "@/lib/constants";
import {
  FileCheck, Compass, BarChart3, Phone, Mail, MapPin,
  Facebook, Instagram, Linkedin, Menu, X, Star, ArrowRight,
  CheckCircle, Users, Clock, Award, ChevronRight, MessageCircle,
  Building, Target, TrendingUp, Shield, Play, XCircle, Zap,
  Eye, Lock, AlertTriangle, Sparkles, ArrowDown, Edit, Trash2,
  Plus, Save, LogOut, Image, Download, ShoppingCart, FileSpreadsheet,
  HelpCircle, ChevronDown, CircleDollarSign, CalendarCheck, PieChart,
  FileText, Wallet, BadgePercent, Sparkle, RefreshCw, ShieldCheck, BookOpen
} from "lucide-react";

const PortaleDocumentiPage = () => (
  <main className="pt-20" data-testid="portale-documenti-page">
    <PageSEO {...SEO.portaleDocumenti} />
    <section className="py-24 bg-[#FAF8F5] min-h-[80vh] flex items-center">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <div className="inline-flex items-center gap-2 bg-[#F7F0E1] text-gold px-4 py-2 rounded-full text-sm font-bold tracking-wider mb-6">
          <FileCheck size={18} />
          AREA RISERVATA CLIENTI
        </div>
        <h1 className="font-heading text-5xl md:text-7xl text-[#0D1527] leading-none mb-6">
          PORTALE<br /><span className="text-gold">DOCUMENTI</span>
        </h1>
        <p className="text-xl text-[#4A5568] max-w-2xl mx-auto mb-4">
          Carica e condividi documenti in modo sicuro con il nostro studio.
          Fatture, contratti, estratti conto: tutto in un unico posto, protetto e sempre accessibile.
        </p>
        <p className="text-[#64708A] mb-10">Accedi al portale per caricare i tuoi documenti o consultare quelli condivisi dal nostro team.</p>
        
        <a
          href="https://app.casalisilvia.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-3 bg-gold text-black hover:bg-[#96742F] px-10 py-5 rounded font-bold text-lg tracking-wide transition-all hover:scale-105 glow-gold"
          data-testid="portale-documenti-cta"
        >
          ACCEDI AL PORTALE <ArrowRight size={20} />
        </a>
        
        <div className="mt-16 grid sm:grid-cols-3 gap-6">
          {[
            { icon: Shield, title: "Sicuro", desc: "Crittografia end-to-end per ogni documento" },
            { icon: Clock, title: "Sempre disponibile", desc: "Accedi 24/7 da qualsiasi dispositivo" },
            { icon: FileCheck, title: "Organizzato", desc: "Tutti i documenti ordinati per categoria" }
          ].map((f, i) => (
            <div key={i} className="bg-white border border-[#E8E2D5] rounded-lg p-6 text-center">
              <f.icon className="text-gold mx-auto mb-3" size={28} />
              <h3 className="font-heading text-lg text-[#0D1527] mb-2">{f.title}</h3>
              <p className="text-[#64708A] text-sm">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  </main>
);

// Pannello Direzionale Page

export { PortaleDocumentiPage };
